// extracted by mini-css-extract-plugin
module.exports = {"container":"StockList_container__1anoN","column":"StockList_column__2CUMw","stockItem":"StockList_stockItem__592qL","borderLine":"StockList_borderLine__3d4KT"};